import { render } from "./AddOverlayTemplate.vue?vue&type=template&id=322fb652&scoped=true"
import script from "./AddOverlayTemplate.vue?vue&type=script&lang=js"
export * from "./AddOverlayTemplate.vue?vue&type=script&lang=js"

import "./AddOverlayTemplate.vue?vue&type=style&index=0&id=322fb652&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322fb652"]])

export default __exports__